// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const AltTagIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'alt-tag'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15L5 13ZM8 15C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13L8 15ZM3.04552 15.7017C2.88079 16.2289 3.17458 16.7897 3.70173 16.9545C4.22887 17.1192 4.78975 16.8254 4.95448 16.2983L3.04552 15.7017ZM6.5 8L7.45448 7.70173C7.32402 7.28425 6.93739 7 6.5 7C6.06261 7 5.67598 7.28425 5.54552 7.70173L6.5 8ZM8.04552 16.2983C8.21025 16.8254 8.77113 17.1192 9.29827 16.9545C9.82542 16.7897 10.1192 16.2289 9.95448 15.7017L8.04552 16.2983ZM16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9V7ZM20 9C20.5523 9 21 8.55228 21 8C21 7.44772 20.5523 7 20 7V9ZM17 16C17 16.5523 17.4477 17 18 17C18.5523 17 19 16.5523 19 16H17ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8H13ZM15 17C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15V17ZM5 15L8 15L8 13L5 13L5 15ZM4.95448 16.2983L7.45448 8.29827L5.54552 7.70173L3.04552 15.7017L4.95448 16.2983ZM5.54552 8.29827L8.04552 16.2983L9.95448 15.7017L7.45448 7.70173L5.54552 8.29827ZM16 9H18V7H16V9ZM18 9H20V7H18V9ZM17 8V16H19V8H17ZM11 8V15.75H13V8H11ZM12.25 17H15V15H12.25V17ZM11 15.75C11 16.4404 11.5596 17 12.25 17V15C12.6642 15 13 15.3358 13 15.75H11Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
AltTagIcon.displayName = 'AltTagIcon'
export { AltTagIcon }
